// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"9f4b683e","80":"158e0094","317":"33748003","390":"c8585dca","785":"ea77a4cd","787":"8741f9c1","889":"f98b7e59","925":"49b67499"}[chunkId] + ".chunk.js";
};